/** Server error body: { message }, sometimes success / isSuccessfull false. */
export const apiErrorMessage = (err, fallback = "Something went wrong") => {
  const data = err?.response?.data ?? err?.data;
  if (data && typeof data === "object" && typeof data.message === "string" && data.message.trim()) {
    return data.message;
  }
  if (typeof data === "string" && data.trim()) return data;
  if (err?.message && !/^Request failed with status code/.test(err.message)) return err.message;
  return fallback;
};
